module.exports = __webpack_public_path__ + "static/media/bathroom.989c49c0.jpeg";